// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__3W-Ho","text":"text__2p8uk","date":"date__2XeA1","button-wrapper":"button-wrapper__1mADZ"};